module.exports = __webpack_public_path__ + "static/zqb-rent.e9d39067.jpg";